module.exports = __webpack_public_path__ + "img/home_middel_right.b132bd6b.png";